<template>
<div class="panel">
    <div class="panel-title">
      <div class="row columns">
        <div class="large-9 columns">
          Dernières activités
        </div>
      </div>
    </div>
    <div>
        <div class="row columns bordered" v-for="notif of notification" @click="notifClicked(notif)">
            <div class="small-3 columns user-icon" @click="notifClicked(notif)">
                <img class="circular" :src="getUserAvatar(notif.actor.id)" alt="team"></td>
            </div>
            <div class="small-9 columns text-left" @click="notifClicked(notif)">
                <div class="row columns">
                    <div class="small-12 description">
                    {{getDescription(notif)}}
                    </div>
                    <div class="small-12 time">
                    <i :class="getIcon(notif)" aria-hidden="true"></i>{{getTime(notif)}}
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import spinner from '../common/spinner.vue'
import { mapGetters } from 'vuex'
import store from '../../store/index.js'
import moment from 'moment'

export default {
  name: 'activityPanel',
  components: {
    spinner
  },
  computed: {
    ...mapGetters([
      'notification'
    ]),
    mrContentType: function () {
      return store.getters.getContent('league_manager', 'matchreport')
    },
    pageContentType: function () {
      return store.getters.getContent('bbc_content', 'content')
    },
    postContentType: function () {
      return store.getters.getContent('bbc_content', 'content')
    },
    teamContentType: function () {
      return store.getters.getContent('league_manager', 'team')
    },
    commentContentType: function () {
      return store.getters.getContent('django_comments', 'comment')
    }
  },
  methods: {
    getIcon (notif) {
      if (notif.action_object_content_type === this.commentContentType.id) {
        return 'fa fa-comment'
      }
      if (notif.action_object_content_type === this.pageContentType.id) {
        return 'fa fa-file-text-o'
      }
      if (notif.action_object_content_type === this.mrContentType.id) {
        return 'fa fa-star'
      }
      if (notif.action_object_content_type === this.teamContentType.id) {
        return 'fa fa-comments'
      }
      if (notif.action_object_content_type === this.postContentType.id) {
        return 'fa fa-microphone'
      }
    },
    notifClicked (notif) {
      // si c'est un commentaire on va sur le contenu parent
      if (notif.action_object_content_type === this.commentContentType.id) {
        if (notif.target.content_type === this.postContentType.id) {
          this.$router.push({name: 'NewsDetail', params: { id: notif.target.object_pk }})
        } else if (notif.target.content_type === this.teamContentType.id) {
          this.$router.push({name: 'TeamDetail', params: { id: notif.target.object_pk }})
        } else if (notif.target.content_type === this.mrContentType.id) {
          this.$router.push({name: 'matchReportDetail', params: { id: notif.target.object_pk }})
        } else if (notif.target.content_type === this.pageContentType.id) {
          this.$router.push({name: 'pageDetail', params: { id: notif.target.object_pk }})
        }
      }
      if (notif.action_object_content_type === this.pageContentType.id) {
        this.$router.push({name: 'pageDetail', params: { id: notif.action_object_object_id }})
      }
      if (notif.action_object_content_type === this.mrContentType.id) {
        this.$router.push({name: 'matchReportDetail', params: { id: notif.action_object_object_id }})
      }
      if (notif.action_object_content_type === this.teamContentType.id) {
        this.$router.push({name: 'TeamDetail', params: { id: notif.action_object_object_id }})
      }
      if (notif.action_object_content_type === this.postContentType.id) {
        this.$router.push({name: 'NewsDetail', params: { id: notif.action_object_object_id }})
      }
    },
    getUserAvatar (userId) {
      let avatar = store.getters.getUserAvatar(userId)
      if (avatar !== null && avatar !== undefined) {
        return avatar.avatar
      }
      return 'http://lorempixel.com/640/480/'
    },
    getDescription (notif) {
      let actor = notif.actor.username
      let action = ''
      // cas de création de commentaire
      if (notif.action_object_content_type === this.commentContentType.id) {
        action = ' a commenté'
        // quel est le contenu commenté
        if (notif.target.content_type === this.postContentType.id) {
          action = action + ' un article'
        } else if (notif.target.content_type === this.teamContentType.id) {
          action = action + ' une equipe'
        } else if (notif.target.content_type === this.mrContentType.id) {
          action = action + ' un match'
        } else if (notif.target.content_type === this.pageContentType.id) {
          action = action + ' une page'
        }
      }
      if (notif.action_object_content_type === this.pageContentType.id) {
        action = ' a publié une page'
      }
      if (notif.action_object_content_type === this.mrContentType.id) {
        action = ' a publié un match'
      }
      if (notif.action_object_content_type === this.teamContentType.id) {
        action = ' a publié une équipe'
      }
      if (notif.action_object_content_type === this.postContentType.id) {
        action = ' a publié un article'
      }
      return actor + action
    },
    getTime (notif) {
      return moment(notif.timestamp, 'YYYY-MM-DDThh:mm:ss').add(2, 'hours').fromNow()
    }
  },
  created () {
    store.dispatch('getNotification')
    store.dispatch('getAllUserAvatar')
    store.dispatch('getContentType')
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.circular {
  border-radius: 15%;
}

.bordered {
    border-top-style: solid;
    border-color: #dadada;
    border-width: 1px;
    padding-bottom: 0.3rem;
    padding-top: 0.3rem;
}

.bordered:hover{
    background-color: #eaeaea;
    cursor: pointer;
}

.description{
    font-size: 14px;
}

.time{
    font-size: 11px;
}

.ranking{
    font-weight: 300;
}

div.ranking-line div{
    margin:0;
    padding:0;
}

.trend-icon-up {
    color: #009900;
    -ms-transform: rotate(-45deg); /* IE 9 */
    -webkit-transform: rotate(-45deg); /* Chrome, Safari, Opera */
    transform: rotate(45deg);
}

.trend-icon-down {
    color: #CC0000;
    -ms-transform: rotate(-135deg); /* IE 9 */
    -webkit-transform: rotate(-135deg); /* Chrome, Safari, Opera */
    transform: rotate(45deg);
}

.trend-icon-neutral {
    color: #BBBBBB;
    -ms-transform: rotate(-90deg); /* IE 9 */
    -webkit-transform: rotate(-90deg); /* Chrome, Safari, Opera */
    transform: rotate(45deg);
}

.small-team-icon {
    width: 25px;
    height: 25px;
}

.ranking tr td{
    padding: 0.5rem 0rem;
    font-size: 0.8em;
}


.ranking td:nth-of-type(5n) {
    font-weight: 400;
}

.ranking tr:hover{
    background-color: #ACB5C3;
    cursor: pointer;
}
.ranking tr:hover td:nth-of-type(5n){
    background-color: #ACB5C3;
    cursor: pointer;
}


.ranking tr td{
    text-align: center;
}

.ranking tr td img{
    width: 25px;
    height: 25px;
}

.ranking td:nth-of-type(1) {
    padding: 0rem 0.5rem
}

.ranking td:nth-of-type(5) {
    padding: 0rem 0.3rem
}

</style>



// WEBPACK FOOTER //
// activity-panel.vue?c4b5f444